export const parsePhone = (phoneNumber: string) => {
  return phoneNumber.replace(/\ /ig, '')
}